import { render, staticRenderFns } from "./GameConfig.vue?vue&type=template&id=fbe17352&scoped=true"
import script from "./GameConfig.vue?vue&type=script&lang=js"
export * from "./GameConfig.vue?vue&type=script&lang=js"
import style0 from "./GameConfig.vue?vue&type=style&index=0&id=fbe17352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe17352",
  null
  
)

export default component.exports